/* import __COLOCATED_TEMPLATE__ from './category-unread.hbs'; */
import Component from "@ember/component";
import { classNames, tagName } from "@ember-decorators/component";

@tagName("span")
@classNames("category__badges")
export default class CategoryUnread extends Component {}
